// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spectrier: PokeData = {
  "id": 897,
  "name": "spectrier",
  "height": 20,
  "weight": 445,
  "base_experience": 290,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "stomp",
    "double-kick",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "disable",
    "agility",
    "confuse-ray",
    "haze",
    "shadow-ball",
    "nasty-plot",
    "hex"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "agility",
    "confuse-ray",
    "shadow-ball",
    "spectral-chain",
    "shadow-dagger",
    "night-shade",
    "shadow-claws",
    "poltergeist",
    "lick",
    "spectral-snatch",
    "curse"
  ],
  "evolution_chain": {
    "id": 475,
    "item": null,
    "species": [
      {
        "name": "spectrier",
        "order": 897,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 144,
    "ability_power": 161
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
